/**
 * This service takes care of polling the server to check if a payment has been processed. Once the server reports
 * that it is, then this service calls a callback for showing a thank you page. If a timeout happens and server
 * still hasn't processed it, then a second callback is called to show the customer a message to contact support, etc.
 *
 * Actual usage: Once stripe payment is confirmed client side (i.e stripe.js tells us they were successfully charged),
 * this function waits for the server to receive the webhook and process the payment (relying on webhook from Stripe
 * instead of client in case they disconnect or close the window and then the payment wont be processed). This
 * function will basically poll the server until the webhook is received & processed, and once it is, we show a
 * thank you page w/ the new credits, etc
 */
export default function(intentId,
                        getStatus,
                        handleSuccess,
                        handleTimeout){
    const that = this;

    const timeoutSecs = 5 * 60;  //mins * 60
    const timeoutMillis = timeoutSecs * 1000;
    const delayBetweenPollsMillis = 1000; //1 second

    let startedAt = null;

    let finished = false;

    const payload = {
        intent_id: intentId
    };

    that.start = start;

    function start() {
        if (startedAt !== null) {
            window.console.error("start() called twice on the same instance of TxnStatusPoller");
            return;
        }

        startedAt = new Date();
        poll();
    }

    function poll() {
        window.console.log("Polling for txn status");

        getStatus(payload).then(result => {
           window.console.log("Received txn status:", result);

           if (result.finished === true) {
               finished = true;
               window.console.log("Txn status = paid, stopping polling", result);
               handleSuccess(result);
           } else {
               window.console.log(`Txn not paid yet, polling again in ${delayBetweenPollsMillis} millis`, result);
               if (! isTimedOut())
                setTimeout(poll, delayBetweenPollsMillis);
               else
                   handleTimeout();
           }
        });
    }

    function isTimedOut() {
        const elapsedMillis = new Date().getTime() - startedAt.getTime();
        window.console.log("Elapsed: " + elapsedMillis + " / " + timeoutMillis);
        return elapsedMillis >= timeoutMillis;
    }

}